import { render, staticRenderFns } from "./Polyglot.vue?vue&type=template&id=345dc30c&scoped=true&"
import script from "./Polyglot.vue?vue&type=script&lang=js&"
export * from "./Polyglot.vue?vue&type=script&lang=js&"
import style0 from "./Polyglot.vue?vue&type=style&index=0&id=345dc30c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345dc30c",
  null
  
)

export default component.exports